import { Spinner } from '@fluentui/react-components'
import styles from './LoadingSpinner.module.scss'

interface LoadingSpinnerProps {
  message?: string
}

export function LoadingSpinner({
  message = 'Loading booking data...',
}: LoadingSpinnerProps) {
  return (
    <div className={styles.wrap}>
      <Spinner size="huge" />
      <div className={styles.message}>{message}</div>
    </div>
  )
}
